import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Minus, Plus } from 'lucide-react';
import type { HomeFaqItem } from '../../data/homeFaq';
import { trackEvent } from '../../utils/analytics';
type HomeFaqProps = {
  heading: string;
  items: HomeFaqItem[];
};

/** "Before your first visit" accordion on the homepage. */
export function HomeFaq({
  heading,
  items
}: HomeFaqProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-16 lg:py-20 bg-ivory border-t border-stone-200" aria-labelledby="home-faq-heading" data-id="element-578" data-mp="15r0v8cw4qkn9">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-579" data-mp="1apu5lwg4dvj7">
        <h2 id="home-faq-heading" className="text-3xl md:text-4xl font-medium text-forest-900 text-center mb-8 lg:mb-10" data-id="element-580" data-mp="1fgu3p50z6jna">
          {heading}
        </h2>
        <div data-id="element-581" data-mp="hzc6f6iioeb2">
          {items.map((item, idx) => {
          const isOpen = openIndex === idx;
          const panelId = `home-faq-panel-${idx}`;
          const buttonId = `home-faq-button-${idx}`;
          return <div key={item.q} className="border-b border-beige/60 last:border-b-0" data-id="element-582" data-mp="1vl9ke9epeg7h" data-mpi={idx}>
                <h3 data-id="element-583" data-mp="1qsyix24bemct">
                  <button id={buttonId} type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpenIndex(isOpen ? null : idx)} className="w-full flex items-center justify-between gap-4 py-5 text-left group" data-id="element-584" data-mp="1qsgevjbev3uc">
                    <span className="text-lg font-medium text-charcoal group-hover:text-forest-600 transition-colors duration-150" data-id="element-585" data-mp="17wgh1rvr562u">
                      {item.q}
                    </span>
                    <span className={`flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-colors duration-150 ${isOpen ? 'bg-forest-600 text-white' : 'bg-stone-200 text-stone-500'}`} aria-hidden="true" data-id="element-586" data-mp="329oelrb43vs6">
                      {isOpen ? <Minus className="w-4 h-4" data-id="element-587" data-mp="10d78u1yzfdfd" /> : <Plus className="w-4 h-4" data-id="element-588" data-mp="lob1y88nw6gc" />}
                    </span>
                  </button>
                </h3>
                <div id={panelId} role="region" aria-labelledby={buttonId} hidden={!isOpen} className="pb-5" data-id="element-589" data-mp="1ebnqup2aoqct">
                  <p className="text-charcoal-light leading-relaxed" data-id="element-590" data-mp="15biiabld7lx2">
                    {item.a}
                  </p>
                  {item.link && (item.link.external ? <a href={item.link.href} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('whatsapp_click', {
                page: 'home',
                position: `faq_${idx + 1}`
              })} className="mt-2 inline-flex items-center gap-1.5 min-h-[44px] text-forest-700 font-medium underline-offset-4 hover:underline" data-id="element-591" data-mp="3q0oq42xyi3qi">
                        {item.link.label}
                        <ArrowRight className="w-4 h-4" aria-hidden="true" data-id="element-592" data-mp="33tkm2nrvtqlq" />
                      </a> : <Link to={item.link.href} className="mt-2 inline-flex items-center gap-1.5 min-h-[44px] text-forest-700 font-medium underline-offset-4 hover:underline" data-id="element-593" data-mp="2yvj09v32nd6k">
                        {item.link.label}
                        <ArrowRight className="w-4 h-4" aria-hidden="true" data-id="element-594" data-mp="2l0qdcbkuqupy" />
                      </Link>)}
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}